<template>
  <div class="link_gift_desBox">
        <header>{{ $t('guanxi_gift_rule_title') }}</header>
        <p>1. {{ $t('guanxi_gift_rule_1') }}</p>
        <p>2. {{ $t('guanxi_gift_rule_2') }}</p>
        <p>3. {{ $t('guanxi_gift_rule_3') }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "link_gift_des",
    data() {
      return {
        client:'',
        langType:'en'
      };
    },
    created() {
        this.parseLangType();
        this.language();
        this.judgeClient();
    },
    mounted() {
    },
    methods: { 
        // 关闭webview半开
        returnBtn() {
            this.$completes.complete("getPreviousPage");
        },
        // 判断平台
        judgeClient() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            this.client = 'iOS';
        } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
            this.client = 'Android';
        } else {
            this.client = 'PC';
        }
        return this.client;
        },
        // 解析语言类型，兼容所有格式
        parseLangType() {
          const query = this.$route.query;
          
          // 1. 标准方式：直接有 langType 参数
          if (query.langType) {
            this.langType = query.langType;
            return;
          }
          
          // 2. 处理错误格式：isShowNav 参数包含 langType
          if (query.isShowNav) {
            let value = query.isShowNav.toString();
            
            // 解码 URL 编码的 ?
            if (value.includes('%3F') || value.includes('%3f')) {
              value = decodeURIComponent(value);
            }
            
            // 检查是否包含 langType
            if (value.includes('langType=')) {
              // 提取 langType 值
              const match = value.match(/langType=([^&]+)/);
              if (match && match[1]) {
                this.langType = match[1];
                return;
              }
            }
          }
          
          // 3. 默认值
          this.langType = 'en';
        },
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == "fr") {
              this.$i18n.locale = "fr"
            } else if (langs == "id") {
              this.$i18n.locale = "id"
            } else if (langs == "ms") {
              this.$i18n.locale = "ms"
            } else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('guanxi_gift_rule_title')
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
html[lang="ar"] .link_gift_desBox {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .link_gift_desBox{
    font-family: 'Montserrat';
    padding: 40px;
    width: 100%;
    height: 100vh;
    /* background: url('../../assets/link_gift_des/bg.png') no-repeat; */
    /* background-size: 100% 100%; */
    box-sizing: border-box;
    color: #262427;
    position: relative;
    background-color: #F5F6F8;
  }
  .link_gift_desBox header{
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 56px;
    text-align: center;
  }
  .link_gift_desBox p{
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 28px;
  }
  .closeBtn{
    position: absolute;
    top: 32px;
    right: 40px;
    width: 22px;
    height: 19px;
    background: url('../../assets/link_gift_des/close.png') no-repeat;
    background-size: 100% 100%;
  }
  
  </style>
  